export const getSafetyStatus = (statusId: string) =>
  statusId === "0" ? "Open" : "Close"
